// Compass Typography compatibility layer.
//
// When the flag is ON, UIKit Typography compound components render via Compass
// Typography instead.  The following UIKit props are intentionally DROPPED in the
// Compass path because Compass variants encode them:
//   - weight  (500+ call sites override this — the Compass variant dictates weight)
//   - leading  (line-height is baked into the Compass variant)
//   - tracking (letter-spacing is baked into the Compass variant)
//   - size    (font-size is baked into the Compass variant)
//
// Non-color classes mixed into the `color` prop (e.g. "underline") are extracted
// via `extractExtraClasses` and passed through as className (outside filterClassName).
//
// Colors that don't map to a Compass semantic token will fall back to the
// Compass default ("primary").

/* eslint-disable no-barrel-files/no-barrel-files -- Compatibility layer that re-exports UIKit Typography sub-components */

import { BodyLg, BodyMd, BodySm, BodyXs } from "./body";
import {
  LabelXl,
  LabelLg,
  LabelMd,
  LabelSm,
  LabelXs,
  LabelXsPlus,
  LabelXxs,
} from "./labels";
import { TitleXxl, TitleXl, TitleLg, TitleMd, TitleSm } from "./titles";

export type {
  TitleXxlProps,
  TitleXlProps,
  TitleLgProps,
  TitleMdProps,
  TitleSmProps,
} from "./titles";
export type {
  LabelXlProps,
  LabelLgProps,
  LabelMdProps,
  LabelSmProps,
  LabelXsProps,
  LabelXsPlusProps,
  LabelXxsProps,
} from "./labels";
export type {
  BodyLgProps,
  BodyMdProps,
  BodySmProps,
  BodyXsProps,
} from "./body";

export const Typography = {
  TitleXxl,
  TitleXl,
  TitleLg,
  TitleMd,
  TitleSm,
  LabelXl,
  LabelLg,
  LabelMd,
  LabelSm,
  LabelXs,
  LabelXsPlus,
  LabelXxs,
  BodyLg,
  BodyMd,
  BodySm,
  BodyXs,
};
